import { render } from "./SetSettings.vue?vue&type=template&id=3a271d24"
import script from "./SetSettings.vue?vue&type=script&lang=js"
export * from "./SetSettings.vue?vue&type=script&lang=js"

import exportComponent from "/Users/dima/Documents/mybackup/backup/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__